import{useState,useEffect,useCallback}from"react";
import{authApi}from"../../lib/authApi";
import type{Me}from"../../lib/authApi";
import{AuthScreen}from"./AuthScreen";
import type{JSX}from"react";

/**
 * Canonical primary-authentication gate.
 *
 * Authentication and privileged Security Authority elevation are deliberately
 * separate concerns. This gate proves the normal KNSAIX auth session only.
 */
export function AuthGate({
 children,
}:{
 children:(identity:Me)=>JSX.Element;
}){
 const[identity,setIdentity]=useState<Me|null|undefined>(undefined);

 const check=useCallback(()=>{
  authApi.me()
   .then(me=>setIdentity(me))
   .catch(()=>setIdentity(null));
 },[]);

 useEffect(()=>{void check();},[check]);

 if(identity===undefined){
  return(
   <div className="auth-gate-splash">
    <span>Checking identity…</span>
   </div>
  );
 }

 if(identity===null){
  return <AuthScreen onAuthenticated={()=>void check()}/>;
 }

 return <>{children(identity)}</>;
}
